import {useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../Constants";
import {Box} from "@mui/material";
import DetailTable from "../../components/UI/table/cutting/details/DetailTable";
import ModalAlert from "../../components/UI/table/customer-detales/ModalAlert";
import DetailReserveService from "../../API/organization/DetailReserveService";
import {BreadcrumbsComponent} from "../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {withFilter} from "../../data/FilterTables/withFilterHOC";
import {DetailFilterData} from "../../data/FilterTables/DetailFilterData";


const DetailReserve = ({isModal, selectedString, setSelectedString}) => {
    const ComponentDetailWithFilter = useMemo(() => {
        return withFilter(DetailTable, DetailFilterData);
    }, []);
    const pathname = useLocation().pathname
    const [alertData, setAlertData] = useState({});
    const [data, setData] = useState([]);
    const [unableCut, setUnableCut] = useState({});
    const [unableTurn, setUnableTurn] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);
    const [modalStatusOpen, setModalStatusOpen] = useState(false);
    const [status, setStatus] = useState(true);
    const [typeStatus, setTypeStatus] = useState(null);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    useEffect(() => {
        getStartPageSize()
        DetailReserveService.getAll().then(function (response) {
            let data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: data?.length}))
            data.forEach((row) => {
                unableCut[row.id] = row.cut;
                unableTurn[row.id] = row.turn;
            });
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            {!isModal && <BreadcrumbsComponent
                page={"Резервы деталей"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>}
            <Box sx={{display: "flex", flexDirection: "column"}}>
                {!isModal && <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Резервы деталей
                    </Typography>
                </Box>}
                <ComponentDetailWithFilter
                    data={data}
                    setData={setData}
                    unableCut={unableCut}
                    unableTurn={unableTurn}
                    setUnableCut={setUnableCut}
                    setUnableTurn={setUnableTurn}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    modalStatusOpen={modalStatusOpen}
                    setModalStatusOpen={setModalStatusOpen}
                    status={status}
                    setStatus={setStatus}
                    typeStatus={typeStatus}
                    setTypeStatus={setTypeStatus}
                    expanded={true}
                    pageSize={100}
                    isColumnCut={true}
                    isColumnTurn={true}
                    isColumnMaterial={true}
                    enableRowSelection={false}
                    enableEditing={true}
                    handleModalAlert={handleModalAlert}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    isButtonAddDetail={true}
                    isReserve={true}
                    isModal={isModal}
                    selectedString={selectedString}
                    setSelectedString={setSelectedString}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
            </Box>
        </Box>
    );
};

export default DetailReserve;